import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Gives /admin/* its own home-screen identity. The app-wide manifest points
 * "Add to Home Screen" at the DJ app (start_url /requests, standalone — no
 * address bar), so without this an admin saving the dashboard to their phone
 * gets an icon that opens the DJ side with no way to navigate out. On admin
 * routes we swap in manifest-admin.json ("Admin", opens on All Payouts) and
 * swap back on leave — Safari reads whichever manifest the page links at the
 * moment the user taps Add to Home Screen.
 */
export default function AdminManifestSwap() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (link) link.href = isAdmin ? "/manifest-admin.json" : "/manifest.json";

    // iOS home-screen label — belt-and-braces alongside the manifest name.
    let meta = document.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-title"]');
    if (isAdmin) {
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "apple-mobile-web-app-title";
        document.head.appendChild(meta);
      }
      meta.content = "Admin";
    } else if (meta) {
      meta.remove();
    }
  }, [isAdmin]);

  return null;
}
